import { CountryCode } from 'libphonenumber-js';
import { AddressInput, CustomerInfoMarketing, Maybe } from '@buy-viasat/types/build/bv';
import { FormFieldState } from '../types';

export type Individual = {
  partyId: string;
  dateOfBirth?: string;
  addContactMethods?: ContactMethodInput[];
  removeContactMethods?: string[];
};

type ContactMethodInput = {
  addressLines?: string[];
  contactMethodId?: string[];
  contactMethodType: ContactMethodType;
  countryCode?: string;
  email?: string;
  labels?: string[];
  municipality?: string;
  notes?: string;
  phoneNumber?: string;
  postalCode?: string;
  region?: string;
};

enum ContactMethodType {
  AddressContactMethod = 'AddressContactMethod',
  EmailContactMethod = 'EmailContactMethod',
  MediaContactMethod = 'MediaContactMethod',
  PhoneContactMethod = 'PhoneContactMethod',
}

export type PersonalInformationState = {
  individual: Individual | undefined;
  email: FormFieldState<string>;
  firstName: FormFieldState<string>;
  lastName: FormFieldState<string>;
  phone: FormFieldState<string>;
  phoneCountryCode?: CountryCode;
  mobileNumber: FormFieldState<string>;
  showConfirmBillingAddress: boolean;
  isPersonalInformationLoading: boolean;
  isDisclaimerCheckboxChecked: boolean;
  previousCustomerInfo: CustomerInfoMarketing;
  isMobileNumberChecked: boolean;
  isPersonalInformationRequestComplete: boolean;
};

export type PartyId = { partyId: string };

export type ErrorPayload<T = string> = {
  callingSaga: string;
  err: T;
  payload: string | null;
};

export type NavigationGeneratorAction = {
  billingAddress: Maybe<AddressInput> | undefined;
  shippingAddress: Maybe<AddressInput> | undefined;
  serviceAddress: AddressInput;
};

export const initialPersonalInformationState: PersonalInformationState = {
  individual: undefined,
  email: { value: '', valid: null, hintText: 'Email is required' },
  firstName: { value: '', valid: null, hintText: 'First name is required' },
  lastName: { value: '', valid: null, hintText: 'Last name is required' },
  phone: { value: '', valid: null, hintText: 'Phone is required' },
  mobileNumber: { value: '', valid: true, hintText: '' },
  showConfirmBillingAddress: false,
  isPersonalInformationLoading: false,
  isDisclaimerCheckboxChecked: false,
  previousCustomerInfo: {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    serviceAddress: '',
  },
  isMobileNumberChecked: false,
  isPersonalInformationRequestComplete: false,
};
